// Jun 2026 (Randy) — in-app counterpart to the restriction emails.
//
// WHY: before this, a creator discovered a billing restriction only by trying
// to top up or withdraw and getting a 403 back. Discovery-on-failure is the
// worst possible way to learn your account is limited. Wording follows the
// approved policy language: nothing is deducted, ever.
import { Warning } from "@phosphor-icons/react";
import { SUPPORT_EMAIL } from "@/lib/contact";

const COPY = {
  voucher_purchases_restricted: "Buying new AI credit",
  voucher_flush_restricted: "Withdrawing credit as cash",
  suspended_for_review: "Full platform access",
};

export default function VoucherRestrictionNotice({ restrictions, context = "dashboard" }) {
  const active = Object.keys(COPY).filter((k) => restrictions?.[k]);
  if (active.length === 0) return null;

  return (
    <div
      className="mb-3 rounded-lg border border-[#E5BBA8] bg-[#FDF1ED] px-3 py-2.5"
      data-testid={`voucher-restriction-notice-${context}`}
    >
      <div className="flex items-center gap-2 mb-1.5">
        <Warning size={13} weight="duotone" className="text-[#7A3A2A] shrink-0" />
        <span className="text-[11px] font-medium text-[#1C1B1A]" data-testid="voucher-restriction-title">
          Part of your account is paused
        </span>
      </div>
      <ul className="text-[10px] text-[#7A3A2A] leading-snug mb-1.5 pl-3.5 list-disc">
        {active.map((k) => (
          <li key={k} data-testid={`voucher-restriction-${k}`}>{COPY[k]}</li>
        ))}
      </ul>
      <div className="text-[10px] leading-snug text-[#6B6A68]" data-testid="voucher-restriction-explainer">
        This follows a billing review. Everything else works normally — your silos, your
        existing credit and your AI usage are unaffected, and nothing has been deducted from
        your balances, your earnings or your referral payouts. Email {SUPPORT_EMAIL} and
        we&apos;ll walk you through what&apos;s needed to lift it.
      </div>
    </div>
  );
}
